// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ConfigProvider } from 'antd';
import ruRU from 'antd/es/locale/ru_RU';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';
import { store } from './app/providers/redux/store';
import { initAuthInterceptor } from './shared/common/api/middleware';
import 'moment/locale/ru';
moment.locale('ru');


initAuthInterceptor().finally(() => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <ConfigProvider locale={ruRU}>
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );


});
